import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Shield, Flame } from "lucide-react";
import { AffiliateButton } from "./Affiliate";
import { SiteSearch } from "./SiteSearch";
import { NORD, SITE } from "../data/vpns";

const NAV = [
  { label: "Best VPNs", to: "/best-vpns" },
  { label: "Reviews", to: "/reviews" },
  { label: "Compare", to: "/compare" },
  { label: "Best VPN For", to: "/best-vpn-for" },
  { label: "Rankings", to: "/rankings" },
  { label: "Learn", to: "/learn" },
  { label: "Blog", to: "/blog" },
  { label: "News", to: "/news" },
  { label: "Deals", to: "/deals", hot: true },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0F172A]/85 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-8">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2 text-white">
          <Shield size={22} className="text-[#4687FF]" fill="#4687FF" fillOpacity={0.25} />
          <span className="font-display text-lg font-extrabold tracking-tight">
            VPNReviews<span className="text-[#4687FF]">.ai</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-6 xl:flex" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace(/\//g, "")}`}
              className={({ isActive }) =>
                n.hot
                  ? `inline-flex items-center gap-1 text-[13px] font-bold tracking-wide transition-colors duration-150 ${
                      isActive ? "text-amber-300" : "text-amber-400 hover:text-amber-300"
                    }`
                  : `text-[13px] font-semibold tracking-wide transition-colors duration-150 ${
                      isActive ? "text-[#4687FF]" : "text-slate-300 hover:text-white"
                    }`
              }
            >
              {n.hot && <Flame size={13} className="animate-pulse" />}
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 xl:flex">
          <SiteSearch />
          <AffiliateButton href={NORD.link} testId="header-nordvpn-cta" className="!px-5 !py-2 !text-[13px]">
            Get NordVPN
          </AffiliateButton>
        </div>
        <div className="flex items-center gap-3 xl:hidden">
          <SiteSearch />
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="text-white"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-white/10 bg-[#0F172A] px-6 pb-6 pt-4 xl:hidden" data-testid="mobile-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              className={`flex items-center gap-1.5 py-2.5 text-sm font-semibold ${
                n.hot ? "text-amber-400 hover:text-amber-300" : "text-slate-200 hover:text-[#4687FF]"
              }`}
            >
              {n.hot && <Flame size={14} />}
              {n.label}
            </NavLink>
          ))}
          <AffiliateButton href={NORD.link} testId="mobile-nordvpn-cta" className="mt-4 w-full">
            Get NordVPN — Our #1 Pick
          </AffiliateButton>
        </nav>
      )}
      <div className="border-t border-white/5 bg-[#0B1222] py-1.5 text-center" data-testid="trust-signal-bar">
        <p className="px-4 text-[11px] font-medium tracking-wide text-slate-400">
          38 reviews published · Updated {SITE.updated} · Editorially independent — we rank on merit
        </p>
      </div>
    </header>
  );
};
